import imageUrlBuilder from '@sanity/image-url'
import { client } from "../sanity.cli"

// Image Builder with Sanity
const builder = imageUrlBuilder(client);

export default function urlFor(source) {
    return builder.image(source).url();
}
